export default class FiltroDevolucoes{
    constructor () {
        this.CodigoProduto= undefined;
        this.NomeProduto= undefined;
        this.Situacao= undefined;
        this.PeriodoInicio = undefined;
        this.PeriodoFim = undefined;
        this.UnidadeId= undefined;
        this.ClienteId= undefined;
        this.RepresentanteId = undefined;
    }
}